import { render, staticRenderFns } from "./orderItemApplyAllDiscountPopover.vue?vue&type=template&id=2ff859a6&"
import script from "./orderItemApplyAllDiscountPopover.vue?vue&type=script&lang=js&"
export * from "./orderItemApplyAllDiscountPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports